import { render } from "./DurationsCom.vue?vue&type=template&id=c51a63fc&scoped=true"
import script from "./DurationsCom.vue?vue&type=script&lang=js"
export * from "./DurationsCom.vue?vue&type=script&lang=js"

import "./DurationsCom.vue?vue&type=style&index=0&id=c51a63fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51a63fc"]])

export default __exports__